import { ApiClient } from '@/shared/api-client';
import _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MetricsModalOpener } from '../metrics-modal-opener'


@Component({
    components: {

    }
})
export default class MetricsMenuItemComponent extends Vue {

    @Prop() public translations!: { [key: string]: string; };

    @Prop() public organizationalUnitPaths!: string[];

    @Prop({ default: 'sv-SE' }) public language!: string;

    private apiClient: ApiClient = new ApiClient();

    constructor() {
        super();
    }

    public async open($event: MouseEvent): Promise<void> {

        $event.preventDefault();

        const containerElement = this.$refs.container as Element;

        await MetricsModalOpener.openAsync(containerElement, this.organizationalUnitPaths, this.translations, this.language);
    }
}
